import React, { Component } from 'react';
import { Form, Grid, Button, Input } from 'semantic-ui-react';
// import { SearchInputBox } from '../Commons';

class AuthStaffSearchForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fn, keyword } = this.props;
    const { handleChange, handleSubmit, handleEntSubmit } = fn;

    return (
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group className="right">
                <Input
                  value={keyword || ''}
                  onChange={handleChange}
                  onKeyPress={handleEntSubmit}
                  placeholder="ID, 이름 검색"
                />
                <Button type="button" icon="search" style={{ padding: '1px 8px 1px 8px' }} onClick={handleSubmit} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

export default AuthStaffSearchForm;
